module.exports = __webpack_public_path__ + "c2df325b6ffc883b2007c361a94ae70d.svg";